import React from 'react'
import PropTypes from 'prop-types'
import advantageMocks from '../../../mocks/advantages'
import Advantage from './Advantage'
import withErrorBoundary from '../../../decorators/withErrorBoundary'
import styled from 'styled-components'

function Advantages(props) {
  const {
    productName,
    condition: { options },
  } = props

  const material = options && options.material

  let advantages

  if (advantageMocks[productName]) {
    advantages =
      advantageMocks[productName][material] || advantageMocks[productName]
  } else {
    advantages = advantageMocks.default
  }

  return (
    <Container>
      {advantages.map(({ icon, text }) => (
        <Advantage key={icon} icon={icon} text={text} />
      ))}
    </Container>
  )
}

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 4fr);
`

Advantages.propTypes = {
  productName: PropTypes.string,
  condition: PropTypes.object,
}

export default withErrorBoundary(Advantages)
